const SET_BESTSELLERS_RECS = 'SET_BESTSELLERS_RECS';
const SET_BESTSELLERS_RECS_ERR = 'SET_BESTSELLERS_RECS_ERR';
const RESET_BESTSELLERS_RECS = 'RESET_BESTSELLERS_RECS';

export {
    SET_BESTSELLERS_RECS, SET_BESTSELLERS_RECS_ERR, RESET_BESTSELLERS_RECS
};
